import { IApplicationState } from '../../types/redux';
import { TSetNewAnswerFormOpenPayload } from '../../actions/newAnswer/openFormActions';
import { getAnswerById } from '../answers';
import { IQuestionAnswer, IReviewAnswer } from '../../types/answers';

export const getAnswerTargetId = (openId: TSetNewAnswerFormOpenPayload | null) => (state: IApplicationState) => {
  if (!openId) {
    return '';
  }

  const { id, type } = openId;

  if (type === 'answer') {
    const answer = getAnswerById(id)(state);

    return (answer as unknown as IReviewAnswer).reviewId || (answer as unknown as IQuestionAnswer).questionId;
  }

  return openId.id;
};
